import { CommandGroup, CommandItem, ScrollArea } from '@ais-ui/ui-core';
import { useMemo } from 'react';
import { cn } from '@ais-ui/utils';
import { PiAnchorThin } from 'react-icons/pi';
import {
  RecentSearch,
  useRecentSearches,
} from '../../../components/RecentSearchesProvider';
import { useLocalization } from '@ais-ui/locale-management';

interface RecentPortSearchesProps {
  onRecentSearchClick: (search: RecentSearch) => void;
}

export const RecentPortSearches = ({ onRecentSearchClick }: RecentPortSearchesProps) => {
  const { messages } = useLocalization();
  const { recentSearches } = useRecentSearches();

  const recentPortSearches = useMemo(
    () => recentSearches.filter((s) => s.type === 'port'),
    [recentSearches]
  );

  // Calculate dynamic height based on number of items
  const itemHeight = 52; // Height per item in pixels
  const maxHeight = 256; // Maximum height
  const calculatedHeight = Math.min(recentPortSearches.length * itemHeight, maxHeight);

  if (recentPortSearches.length === 0) {
    return (
      <div className="py-6 text-center text-sm">
        {messages.shipSearchMinChars}
      </div>
    );
  }

  return (
    <>
      <CommandGroup heading={messages.mapSearchRecentSearchesHeading} />
      <ScrollArea className="max-h-[256px]" style={{ height: `${calculatedHeight}px` }}>
        {recentPortSearches.map((search) => (
          <CommandItem
            key={search.id}
            className="mr-4 py-2 hover:cursor-pointer hover:bg-transparent data-[selected=true]:bg-transparent group border-b border-border last:border-b-0"
            onSelect={() => onRecentSearchClick(search)}
          >
            <div className="flex flex-col space-y-1 w-full">
              <div className="flex justify-between items-center">
                <div className="flex items-center space-x-1">
                  <PiAnchorThin className="mr-2 size-4 text-blue-600" />
                  <span className="group-hover:underline">{search.name}</span>
                </div>
              </div>
              <div className="flex space-x-2 text-xs text-muted-foreground items-center">
                <div>Locode: {search.metadata.locode}</div>
                <div className={cn('rounded-full h-1 w-1 bg-blue-600')} />
                <div>Country: {search.metadata.country}</div>
              </div>
            </div>
          </CommandItem>
        ))}
      </ScrollArea>
    </>
  );
};
